import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import { Button, Image, Form, Col } from "react-bootstrap";
import { CloseIcon, PlayIcon } from "../data/iconImage";
import { useAlert } from "../context/AlertContext";
import LoadingSpinner from "./LoadingSpinner";

const MediaUploader = ({
  accept = "*",
  buttonIcon,
  buttonName,
  onSubmitCallbackMedia
}) => {
  const fileInputMedia = useRef(null);
  const { showAlert } = useAlert();

  const handleMediaChange = (e) => {
    const files = Array.from(e.target.files);
    e.target.value = null;

    if (files.find(({ size }) => size > 1024 * 1024 * 25)) {
      return showAlert({
        error: "คำเตือน",
        message: "ขนาดไฟล์ใหญ่เกินไป กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 25 MB",
        type: "warning"
      });
    }

    onSubmitCallbackMedia({ files });
  };

  return (
    <>
      <Button
        variant="success"
        className="py-2_5 px-4 d-flex justify-content-center align-items-center rounded-pill"
        onClick={() => fileInputMedia.current.click()}
        style={{ width: "170px" }}
      >
        {buttonIcon && (
          <Image className="me-2" src={buttonIcon} alt="Button Icon" />
        )}
        {buttonName && buttonName}
      </Button>

      <Form.Control
        multiple
        type="file"
        accept={accept}
        className="d-none"
        ref={fileInputMedia}
        onChange={handleMediaChange}
      />
    </>
  );
};

const MediaPreviewer = ({
  loading,
  mediaType,
  deletedBtn,
  filePreview,
  onDeleteCallback
}) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    const method = videoRef?.current;
    method?.[method?.paused ? "play" : "pause"]();
    setPlaying(!method?.paused);
  };

  useEffect(() => {
    if (videoRef.current && playing) {
      videoRef.current.play();
    }
  }, [playing]);

  return (
    <>
      {!loading ? (
        <>
          {filePreview.map((preview, index) => (
            <Col
              key={index}
              sm={1}
              className="w-auto me-2 pe-0 position-relative"
              style={{ height: "200px" }}
            >
              {mediaType === "Image" ? (
                <img
                  key={index}
                  className="h-100"
                  src={URL.createObjectURL(preview)}
                  alt={`Preview ${index}`}
                  style={{ borderRadius: "0.625rem" }}
                />
              ) : (
                <>
                  <video
                    controls
                    ref={videoRef}
                    key={preview.name}
                    className="h-100"
                    onPlay={() => setPlaying(true)}
                    onPause={() => setPlaying(false)}
                    src={URL.createObjectURL(preview)}
                    style={{ borderRadius: "0.625rem" }}
                  />
                  <div
                    className={`${
                      !playing ? "h-100" : "h-0"
                    } position-absolute top-0 d-flex justify-content-center align-items-center`}
                    style={{
                      width: "calc(100% - 0.75rem)",
                      borderRadius: "0.625rem",
                      background: "rgba(61, 61, 61, 0.70)",
                      transition: "0.5s ease-out"
                    }}
                  >
                    <Button
                      className={`playButton w-auto h-auto p-0 bg-transparent border-0 rounded-circle`}
                      onClick={togglePlay}
                    >
                      <Image
                        className={!playing ? "w-auto h-auto" : "w-0 h-0"}
                        src={PlayIcon}
                        alt="Play Icon"
                      />
                    </Button>
                  </div>
                </>
              )}
              {deletedBtn && (
                <Button
                  variant="light"
                  className="m-2 p-0 d-flex justify-content-center align-items-center position-absolute top-0 end-0 rounded-circle opacity-50"
                  onClick={() =>
                    onDeleteCallback(filePreview[index], mediaType)
                  }
                  style={{ width: "1.5rem", height: "1.5rem" }}
                >
                  <Image src={CloseIcon} alt="Close Icon" />
                </Button>
              )}
            </Col>
          ))}
        </>
      ) : (
        <div className="text-center">
          <LoadingSpinner />
        </div>
      )}
    </>
  );
};

MediaUploader.propTypes = {
  accept: PropTypes.string,
  buttonIcon: PropTypes.string,
  buttonName: PropTypes.string,
  onSubmitCallbackMedia: PropTypes.func
};

MediaPreviewer.propTypes = {
  mediaType: PropTypes.string.isRequired,
  filePreview: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  deletedBtn: PropTypes.bool,
  onDeleteCallback: PropTypes.func
};

export { MediaUploader, MediaPreviewer };
